<template>
    <div id="app">
        <MenuComponent :canLoad="appLoaded" ref="menu" />
        <router-view class="view" :class="{ loading: !canLoad }" :style="styleVariable" @ready="canLoad = true" />

        <transition name="fade">
            <SearchPopup v-if="search" :search="search" />
        </transition>

        <FooterComponent v-show="canLoad" />
        <CookieConsent />
    </div>
</template>

<script>
import { useHead } from '@unhead/vue'
import CookieConsent from '@/components/CookieConsent'
import FooterComponent from './components/Footer.vue'
import MenuComponent from './components/Menu.vue'
import SearchPopup from '@/components/SearchPopup.vue'
import "@/assets/scss/_wp.scss"

import { TITLE } from "@/constants"

export default {
    name: 'App',
    components: {
        CookieConsent,
        FooterComponent,
        MenuComponent,
        SearchPopup,
    },
    data() {
        return {
            appLoaded: false,
            canLoad: false,
            navigationHeight: 0,
        }
    },
    methods: {
    },
    computed: {
        styleVariable() {
            return {
                '--menu-height': `${this.navigationHeight}px`
            }
        },
        search() {
            if (this.$route.query.search == null) {
                return null
            }
            return this.$route.query.search
        },
    },
    watch: {
        canLoad() {
            this.appLoaded = true
            if (!this.canLoad) {
                return
            }
            this.$nextTick().then(() => {
                this.navigationHeight = this.$refs.menu.$el.offsetHeight;
            })
        },
        $route(n, old) {
            if (n.path == old.path) {
                return
            }
            this.canLoad = false
        },
    },
    mounted() {
        this.$store.dispatch('banners/getSquare')
        this.$store.dispatch('banners/getWide')
    },
    setup() {
        useHead({
            title: TITLE,
        })
    },
}
</script>


<style lang="scss">
@import "@/assets/fonts/haffer/_haffer.scss";
@import "@/assets/scss/_colors.scss";
@import "@/assets/scss/queries";

:root {
    --z-footer: 100;
    --background-color: #{$color-background};
    --menu-height: 120px;
    --side-padding: calc((100vw - var(--content-width))/2);
    --content-inner-padding: calc(var(--content-width) * .05);
    --content-width: 90vw;
    --menu-padding: 2rem;

    --color-background: #{$color-background};
    --color-betano: #{$color-betano};
    --color-text: #{$color-white};

    @include media(sm) {
        --content-width: 1728px;
    }

    @media screen and (max-width: 1800px) {
        --content-width: 90vw;
    }
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

html,
body {
    min-height: 100%;
    background: var(--background-color);
    max-width: 100%;
    font-size: 18px;
}

#app {
    font-family: Haffer, Helvetica, Arial, sans-serif;
    width: 100%;
    overflow: hidden;
}

nav {

    a {
        font-weight: bold;

        &.router-link-exact-active {}
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.view {
    min-height: 100vh;
    position: relative;

    &::after {
        transition: .6s ease-in-out opacity;
        content: '';
        z-index: 500;
        position: absolute;
        background-color: $color-betano;
        pointer-events: none;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }

    &:not(.loading) {
        &::after {
            opacity: 0;
        }
    }
}
</style>
